// extracted by mini-css-extract-plugin
export default {"content":"TabRelacionesComponet_content__8Ng81","nav":"TabRelacionesComponet_nav__4SVj-","a":"TabRelacionesComponet_a__v1ksk","a1":"TabRelacionesComponet_a1__KjL8u"};